import { KeyValue } from '@app/core/components/KeyValue';
import { Box, Chip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { GroupWithUsers } from '../../../../../../core/types/users';
import { getAppUserDisplayName } from '../../../../../../helpers/user';

interface Props {
  readonly group: GroupWithUsers;
}

/**
 * Read-only group details: name and assigned users.
 */
export function GroupInfo({ group }: Props) {
  const { users } = group;

  return (
    <Box>
      <KeyValue label={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}>
        {group.name}
      </KeyValue>
      <KeyValue
        label={
          <FormattedMessage
            id="admin.groups.viewScreen.assignedUsers.title"
            defaultMessage="Usuarios asignados"
          />
        }
      >
        <Box>
          <Box sx={{ mb: users.length > 0 ? 2 : 0 }}>
            <FormattedMessage
              id="admin.groups.viewScreen.assignedUsers.body"
              defaultMessage="Este grupo {count, plural, =0 {no tiene} one {tiene #} other {tiene #} } {count, plural, one {usuario asignado} other {usuarios asignados} }"
              values={{
                count: users.length,
              }}
            />
          </Box>
          {users.length > 0 && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {users.map((u) => (
                <Chip
                  key={u.id}
                  label={getAppUserDisplayName(u)}
                  variant="outlined"
                  size="small"
                />
              ))}
            </Box>
          )}
        </Box>
      </KeyValue>
    </Box>
  );
}
